module.exports = __webpack_public_path__ + "static/media/tech-image-five.a6f5b16f.png";